import { HomeStudentVideoTable } from './HomeStudentVideoTable';
export default HomeStudentVideoTable;
